<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Penyata Bank" >

        <w-card bg-color="" class="">
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Jenis Fail :
                      </h5>
                      <div class="fw-normal my1 fs-1">KAUNTER </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Nama Fail :
                      </h5>
                      <div class="fw-normal my1 fs-1"> BIMB202229898778.txt</div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Transaksi :
                      </h5>
                      <div class="fw-normal my1 fs-1"> 22-01-2021 </div>
                </div>
            </w-flex>
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Proses :
                      </h5>
                      <div class="fw-normal my1 fs-1"> 23-01-2021 01:00:00</div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Diproses Oleh :
                      </h5>
                      <div class="fw-normal my1 fs-1"> Siatem</div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Bil. Rekod :
                      </h5>
                      <div class="fw-normal my1 fs-1"> 100 </div>
                </div>
                </w-flex>
                <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Bil. Rekod Sepadan:
                      </h5>
                      <div class="fw-normal my1 fs-1"> 100 </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Bil. Rekod Ralat:
                      </h5>
                      <div class="fw-normal my1 fs-1"> 0 </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                         
                      </h5>
                      
                </div>
            </w-flex>
        </w-card>

    </z-page>

    <z-page title="Penyata Bank" class="mt3 table-hardcode">
       
        <w-form v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">    
            
            <w-flex justify-center align-center>
                
                <div class="w-card__content content-hardcode">
                  <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Bil.</td>
                            <td>Tarikh Transaksi</td>
                            <td>No. Slip  Bank</td>
                            <td>No. Penyata Pemungut</td>
                            <td>Maklumat Pembayaran</td>
                            <td>Amaun (RM)</td>
                            <td>SEPADAN</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td>1</td>
                            <td>22/01/2021</td>
                            <td>111283473438</td>
                            <td>20JTG0800001</td>
                            <td>TUNAI</td>
                            <td>1000</td>
                            <td>YA</td>
                        </tr>
                        <tr>
                          <td>2</td>
                            <td>22/01/2021</td>
                            <td>111283473439</td>
                            <td>20JTG0800002</td>
                            <td>CEK TEMPATAN</td>
                            <td>2300</td>
                            <td>YA</td>
                        </tr>
                        <tr>
                          <td>3</td>
                            <td>22/01/2021</td>
                            <td>111283473440</td>
                            <td>20JTG0800003</td>
                            <td>CEK LUAR</td>
                            <td>2340</td>
                            <td>YA</td>
                        </tr>
                        <tr>
                          <td>4</td>
                            <td>22/01/2021</td>
                            <td>111283473441</td>
                            <td>20JTG0800004</td>
                            <td>KAD KREDIT</td>
                            <td>3450</td>
                            <td>TIDAK</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
            </w-flex>

            <w-flex class="mt3" wrap align-center justify-end>
                    <w-button bg-color="error-dark1" dark tile @click="destroy(item)">
                         <w-icon dark tile >fal fa-times</w-icon> Tutup
                    </w-button>
                    <!-- <w-button bg-color="warning-dark1" tile @click="edit(item)">
                        <w-icon dark tile >fal fa-arrow-circle-left</w-icon>
                     </w-button>
                     &nbsp;
                     <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile >fal fa-save</w-icon>
                    </w-button> -->
            </w-flex>

        </w-form>

    </z-page>

  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    jenis:'',
    no:'',
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
      resourceurl: 'deposit',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Penyesuaian', route: '/penyesuaian' },
        { label: 'Penyata Bank', route: '/penyesuaian/penyataan-bank' },
        { label: 'Butiran Bank', route: '/penyesuaian/1' },
      ],
    }
  },
  methods: {
    onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    this.$inertia.visit(window.route('bayaran.index'));

  },
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>